import api from '../api'

export default {
    namespaced: true,
    state: {
        userOnlineList: {
            beanList: [],
            total: 0,
            blackListCount: 0,// 黑名单
            grayListCount: 0,// 灰名单
            greenListCount: 0,// 绿名单
            orangeListCount: 0,// 蓝名单
            whiteListCount: 0,// 白名单
        },
        userOnlineATList: {
            beanList: [],
            total: 0
        }
    },
    mutations: {
        setStateUserOnlineList(state, info) {
            state.userOnlineList = info
        },
        setStateUserOnlineATList(state, info) {
            state.userOnlineATList = info
        },
    },
    actions: {
        getUserOnlineList({commit}, params) {
            return api.post('/userOnline/list', '在线玩家列表', params).then(res => {
                commit('setStateUserOnlineList', res.data)
            })
        },
        getUserOnlineExpand(store, userId) {
            return api.post(`/userOnline/expand/${userId}`, '在线玩家 - 展开')
        },
        getUserOnlineATList({commit}, params) {
            return api.post('/userOnline/at/list', 'AT-在线玩家列表', params).then(res => {
                if (res.data.total) {
                    return api.post('/at/user/prop', '在线玩家-玩家额外属性', res.data.beanList.map(item => item.userId)).then(c_res => {
                        res.data.beanList.forEach(item => {
                            c_res.data.forEach(c_item =>{
                                if(c_item.userId == item.userId){
                                    Object.assign(item,c_item)
                                }
                            })
                        });
                        commit('setStateUserOnlineATList', res.data);
                    });
                } else {
                    commit('setStateUserOnlineATList', res.data);
                }
            })
        },
        updateUserLevel(store, params) {
            return api.post('/userOnline/changeLevel', '在线玩家 - 修改用户层级', params)
        },
        getUserOnlineRemarkList(store, params) {
            return api.post('/userOnline/remark/list', '备注记录', params)
        },
        createRemark(store, params) {
            return api.post('/userOnline/remark', '在线玩家 - 备注玩家', params)
        },
    }
}